<template>
  <div id="aInspectionTaskMap" class="map-container"></div>
</template>

<script>
import { queryAdminInspectionTaskDetail } from '@/api/inspection/adminInspectionTaskDetailApi'
import {
  addTiandituLabel,
  addTiandituMarker,
  addTiandituPolyline,
  clearTiandituMap,
  fitTiandituViewport,
  loadTiandituMapScript,
} from '@/utils/tiandituMap'

export default {
  name: 'AInspectionTaskMap',
  data() {
    return {
      map: null,
      points: []
    }
  },
  methods: {
    loadData(params) {
      return this.initMap(params)
    },
    async initMap(params) {
      try {
        const { data } = await queryAdminInspectionTaskDetail({
          taskId: params.taskId,
          page: 1,
          row: 1000
        })
        this.points = data
        await this.initMapView()
      } catch (error) {
        console.error(error)
        this.$message.error(this.$t('common.fetchError'))
      }
    },
    async initMapView() {
      if (!this.points || this.points.length === 0) return
      try {
        await loadTiandituMapScript()
        clearTiandituMap(this.map)
        this.map = new window.T.Map('aInspectionTaskMap', {
          projection: 'EPSG:4326',
        })
        const path = []
        this.points.forEach(point => {
          const completed = point.state === '20200405'
          const result = addTiandituMarker(this.map, point, {
            title: point.inspectionName,
            iconUrl: completed ? '/img/inspection_do.png' : '/img/inspection.png',
          })
          if (!result) return
          addTiandituLabel(
            this.map,
            result.lngLat,
            point.inspectionName,
            completed ? '#CC0000' : '#3777FF',
          )
          path.push(result.lngLat)
        })
        addTiandituPolyline(this.map, path)
        fitTiandituViewport(this.map, path, 17)
      } catch (error) {
        console.error('天地图加载失败:', error)
        this.$message.error(this.$t('tiandituMap.loadFailed'))
      }
    }
  },
  beforeDestroy() {
    clearTiandituMap(this.map)
    this.map = null
  }
}
</script>

<style scoped>
.map-container {
  height: 600px;
  width: 100%;
}
</style>
